import CountryPageRenderer from '../components/CountryPageRenderer';
import montenegroData from '../data/country-pages/montenegro';

export default function MontenegroCountryPage() {
  return <CountryPageRenderer data={montenegroData} />;
}
